import api from "../../request";
import { showLog } from "../../utils/log";
import { SET_COA } from "../constants/xenditConstants";

export const get_CoaXendit = () => async (dispatch) => {
  showLog("XenditActions Masuk get_CoaXendit");
  try {
    const response = await api.apiXendit.coa();
    if (response?.data.length !== 0) {
      dispatch({ type: SET_COA, value: response?.data[0] });
    }
  } catch (error) {
    showLog(`Xendit Actions ${error}`);
  }
};
